import { commonEnums } from '@codametrix/ui-common';
const { ChargeSessionCodeProvenance } = commonEnums;
import './styles/index.scss';
const shouldShowResults = (lookupState: CMxCommonApp.CodeLookupState) => {
  const { active, searching, codeQuery } = lookupState;
  if (!active) {
    return false;
  }
  if (searching) {
    return true;
  }

  return matchRequirements(codeQuery);
};

const matchRequirements = codeQuery => {
  const { text = '', searchType = '' } = codeQuery;
  return (
    text.length > 2 ||
    (text.length === 2 && searchType === ChargeSessionCodeProvenance.MODIFIER)
  );
};

export { shouldShowResults, matchRequirements };
